// @flow
import { useCallback, useState } from 'react';
import classnames from 'classnames';

import WatchClickOutside from '@components/WatchClickOutside';

import css from '@styles/productDetail/comboButton';

type ActionType = {
  name: string,
  title: string
};

type PropsType = {
  actions: Array<ActionType>,
  onClick: (name: string) => void,
  initialText: string
};

export default function ComboButton(props: PropsType) {
  const [open, setOpen] = useState(false);

  const onComboClick = () => setOpen(!open);

  const triggerAction = (name: string): void => {
    setOpen(false);
    props.onClick(name);
  };

  const closeMenu = useCallback(() => setOpen(false), []);

  return (
    <WatchClickOutside
      enabled={open}
      onClickOutside={closeMenu}
      className={css.container}
    >
      <div className={css.centerAlignmentContainer}>
        <button
          onClick={onComboClick}
          className={classnames(css.button, { open })}
        >
          {props.initialText}
          <i className={`fa fa-chevron-${open ? 'up' : 'down'}`} />
        </button>
        {open && (
          <div className={css.actionList}>
            {props.actions.map((action, i) => {
              return (
                <div
                  key={i}
                  className={css.actionListItem}
                  onClick={() => triggerAction(action.name)}
                >
                  {action.title}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </WatchClickOutside>
  );
}
